import { CreatableMultiSelectProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'
import { Combobox, type ComboboxOption } from '@/components/ui/combobox'

export default function CreatableMultiSelect(props: CreatableMultiSelectProps) {
  const {
    inputId,
    label,
    onChange,
    options,
    value,
    onFocus,
    onBlur,
    required,
    disabled
  } = props

  const comboboxOptions: ComboboxOption[] = options.map(option => ({
    label: option.label,
    value: `${option.value}`,
    prefix: option.prefix
  }))

  // Values matching an existing option round-trip as that option's numeric
  // value; anything else is free text the user created.
  function fromComboboxValue(newValue: string): string | number {
    return options.some(option => `${option.value}` === newValue)
      ? Number.parseInt(newValue, 10)
      : newValue
  }

  return (
    <InputFieldset {...props}>
      <Combobox
        multiple
        creatable
        options={comboboxOptions}
        value={(value ?? []).map(v => `${v}`)}
        onChange={values => onChange(values.map(fromComboboxValue))}
        id={inputId}
        aria-label={label}
        required={required}
        disabled={disabled}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </InputFieldset>
  )
}
